import $ from 'jquery'

class TemplateFactory {
  static deliveryBlock () {
    const $deliveryBlockTemplate = $('#delivery-block-template').clone()
    $deliveryBlockTemplate.find('.accordion').removeAttr('style')

    return $deliveryBlockTemplate
  }

  static cartProductBlock () {
    const $productBlockTemplate = $('#product-cart-block-template').clone()
    $productBlockTemplate.find('li').removeAttr('style')

    return $productBlockTemplate
  }

  static checkoutProductBlock () {
    const $productBlockTemplate = $('#product-checkout-block-template').clone()
    $productBlockTemplate.find('li').removeAttr('style')

    return $productBlockTemplate
  }

  static outOfStockProductBlock () {
    const $productBlockTemplate = $('#product-cart-block-outofstock-template').clone()
    $productBlockTemplate.find('li').removeAttr('style')

    return $productBlockTemplate
  }

  static widgetProduct () {
    // Клон вставляется в список виджета как есть: без снятия id в документе
    // плодятся дубли #product-widget-template, и следующий рендер клонирует
    // уже заполненную строку прошлого рендера вместо чистого шаблона
    // (утекают классы/атрибуты, напр. label_post-best_price).
    return $('#product-widget-template').clone().removeAttr('id')
  }
}

export default TemplateFactory
